import React, { useEffect, useState, useRef } from 'react'
import { useTour } from './hooks/useTour'
import { getElement, getRect, scrollToElement } from './utils/tourHelpers'
import './Tour.scss'

const TourOverlay = () => {
    const { isTourActive, currentStep } = useTour()
    const [spotlightStyle, setSpotlightStyle] = useState({})
    const resizeObserverRef = useRef(null)

    const updateSpotlight = () => {
        if (!isTourActive || !currentStep) return

        const element = getElement(currentStep.target)

        if (element) {
            scrollToElement(element)
            const rect = getRect(element)

            setSpotlightStyle({
                top: rect.top,
                left: rect.left,
                width: rect.width,
                height: rect.height,
                opacity: 1
            })
        } else {
            // If element not found, center or hide spotlight
            setSpotlightStyle({ opacity: 0 })
        }
    }

    useEffect(() => {
        if (isTourActive) {
            updateSpotlight()
            window.addEventListener('resize', updateSpotlight)
            window.addEventListener('scroll', updateSpotlight, true)
        }

        return () => {
            window.removeEventListener('resize', updateSpotlight)
            window.removeEventListener('scroll', updateSpotlight, true)
        }
    }, [isTourActive, currentStep])

    // Observe DOM changes to update spotlight if element moves
    useEffect(() => {
        if (isTourActive && currentStep) {
            const element = getElement(currentStep.target)
            if (element) {
                if (resizeObserverRef.current) {
                    resizeObserverRef.current.disconnect()
                }

                resizeObserverRef.current = new ResizeObserver(updateSpotlight)
                resizeObserverRef.current.observe(element)
            }
        }

        return () => {
            if (resizeObserverRef.current) {
                resizeObserverRef.current.disconnect()
            }
        }
    }, [isTourActive, currentStep])

    if (!isTourActive) return null

    // If no spotlight style (element not found), show full overlay
    if (!spotlightStyle.width) {
        return <div className="tour-overlay" style={{ opacity: 0.7, background: 'black' }} />
    }

    return (
        <div className="tour-overlay">
            <svg className="tour-overlay-svg">
                <path
                    className="tour-overlay-path"
                    d={`
                        M 0 0 
                        h ${window.innerWidth} 
                        v ${window.innerHeight} 
                        h -${window.innerWidth} 
                        z 
                        M ${spotlightStyle.left} ${spotlightStyle.top} 
                        v ${spotlightStyle.height} 
                        h ${spotlightStyle.width} 
                        v -${spotlightStyle.height} 
                        z
                    `}
                    fillRule="evenodd"
                />
            </svg>
        </div>
    )
}

export default TourOverlay
